import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import chartPic from "@images/home/mecomChart.png";
import { trendData } from "@home3/homeType";
import { formatRate } from "@/utils/format";
import t201 from "/public/images/t2_01.png";
import t202 from "/public/images/t2_02.png";
import t203 from "/public/images/t2_03.png";
import t204 from "/public/images/t2_04.png";
import { convertToI18, formatDigit } from "@/utils/count";

const Index = () => {
    const { t, i18n } = useTranslation("home");
    return (
        <div className="bg-[#fff] px-[20px] pb-[30px]">
            <div className={styles.title}>{t("ecomTrend")}</div>
            <div className={styles.time}>{t("update12hour")}</div>
            <div className={styles.main}>
                <div className={styles.up}>
                    <div className={styles.box}>
                        <div className={styles.sale}>
                        <span className={styles["t-img"]}>
                            <Image src={t201}></Image>
                            </span>
                                {t("Revenue")}
                            </div>
                        <div className="flex items-baseline">
                            <span className={styles.saleCount}>
                            <div id="js1-bounty" className={` animate-box  cm-in-number js1-bounty`}></div>

                            </span>
                            {/* <span className={styles.saleRate}>
                                {formatRate(trendData?.gmvIncrRate, true)}
                            </span> */}
                        </div>
                    </div>
                    <div className={styles.box1}>
                        <div className={styles.cell}>
                        <div className={styles.sale}>
                        <span className={styles["t-img"]}>
                            <Image src={t202}></Image>
                            </span>
                           {t("Sales Volume")}
                            </div>
                        <div className="flex items-baseline">
                            <span className={styles.saleCount}>
                            <div id="js2-bounty" className={` animate-box  cm-in-number js2-bounty`}></div>


                            </span>
                            </div>
                        </div>
                    </div>
                    <div className={styles.box2}>
                        <div className={styles.cell}>
                            <div className={styles.sale}>
                            <span className={styles["t-img"]}>
                                <Image src={t203}></Image>
                                </span>
                                {t("Products")} 
                                </div>
                            <div className="flex items-baseline">
                                <span className={styles.saleCount}>
                                <div id="js3-bounty" className={` animate-box  cm-in-number js3-bounty`}></div>


                                </span>
                            
                            </div>
                        </div>
                    </div>
                    <div className={styles.box3}>
                        <div className={styles.cell}>
                            <div className={styles.sale}>
                            <span className={styles["t-img"]}>
                                <Image src={t204}></Image>
                                </span>
                                {t('Views')}
                                </div>
                            <div className="flex items-baseline">
                                <span className={styles.saleCount}>
                                <div id="js4-bounty" className={` animate-box  cm-in-number js3-bounty`}></div>


                                </span>
                            
                            </div>
                        </div>
                    </div>
                    <div className={styles.info}>
                        {/* <div>
                            <div className={styles.countName}>
                                {t("produts1")}
                            </div>

                            <div className={styles.count}>
                                {convertToI18(trendData?.productCount)}
                            </div>
                            <div className={styles.countAdd}>
                                {formatRate(
                                    trendData?.productCountIncrRate,
                                    true
                                )}
                            </div>
                        </div>
                        <div>
                            <div className={styles.countName}>
                                {t("salesVolume")}
                            </div>

                            <div className={styles.count}>
                                ${convertToI18(trendData?.totalSales)}
                            </div>
                            <div className={styles.countAdd}>
                                {formatRate(
                                    trendData?.totalSalesIncrRate,
                                    true
                                )}
                            </div>
                        </div> */}
                        {/* <div>
                            <div className={styles.countName}>
                                {t("participants")}
                            </div>
                            <div className={styles.count}>
                                {convertToI18(99)}
                            </div>
                            <div className={styles.countAdd}>
                                {formatRate(1.1, true)}
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className={styles['chart-legend']}>
                        <div className={styles['chart-i']}> {t('Sales Volume')}</div>
                        <div className={styles['chart-i']}>{t('Total Volume')}</div>
                    </div>
                <div className={styles.down}>
              
                    <div className={`${styles['chart-card']} animate-box cm-in-chart`}></div>
                        {/* <Image alt="" src={chartPic}></Image> */}
                </div>
            </div>
        </div>
    );
};
export default Index;
